<template>
    <div class="row article-slider" :class="className">
        <!--div class="col-12">
            <div class="float-filter">
                <a class="label" href="#">Filtrar Por</a>
            </div>
        </div-->
        <div class="col-12" :id="id + '-slider'" :class="id + '-content'">
            <div v-if="items && items.length > 0">
                <VueSlickCarousel
                    ref="slick"
                    v-bind="slickSettings"
                    class="article-slider-content"
                >
                    <a v-for="item in items" :href="item.href" class="featured-el news">
                        <div class="hover-effect"></div>
                        <div class="image" :class="{'no-image': !item.image_url || item.image_url === 0}">
                            <picture v-if="item.image_url && item.image_url.length > 0">
                                <img v-lazy="item.image_url" :alt="item.title">
                                <div class="spinner-border" role="status">
                                  <span class="visually-hidden"></span>
                                </div>
                            </picture>
                            <div class="tag" v-if="displayTags" :class="'tag-with-color ' + item.type" v-text="item.typename"></div>
                        </div>
                        <div class="title" v-text="item.title"></div>
                        <div class="desc" v-text="item.lead"></div>
                        <div class="btn readmore">{{labelReadMore}}</div>
                    </a>
                </VueSlickCarousel>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        components: {VueSlickCarousel},
        props: ['id', 'items', 'className', 'labelReadMore', 'displayTags'],

        watch: {
            items: function() {
                this.$nextTick(() => {
                    if (!this.$refs.slick) return;
                    this.$refs.slick.$emit('reInit');
                });
            },
        },

        data: () => { return {
            currentFilter: '',
            slickSettings: {
                arrows: true,
                adaptiveHeight: false,
                draggable: true,
                slidesToShow: Math.round($(".main-container").width() / 284),
                dots: false,
                infinite: true,
                speed: 300,
                variableWidth: false,
            }
        }},
        mounted() {
          if(this.id === 'featured') {
            this.slickSettings.responsive = [
              {
                breakpoint: 2000,
                settings: {
                  slidesToShow: 5,
                }
              },
              {
                breakpoint: 1400,
                settings: {
                  slidesToShow: 4,
                }
              },
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 3,
                }
              },
              {
                breakpoint: 950,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                }
              },
            ]
          }
        },
    }
</script>
